import { render, staticRenderFns } from "./TotalVariety.vue?vue&type=template&id=37979eb0&"
import script from "./TotalVariety.vue?vue&type=script&lang=js&"
export * from "./TotalVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports